import Dropzone from 'react-dropzone';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { ACCEPTED_FILE_TYPES } from '../../../config/accepted-file-types';
import { InvalidPDFs } from './InvalidPDFs';
import {
  useHandleUploadDocuments,
  useValidateDocuments,
} from '../../../utils/DocumentsHooks';
import { CARRIER_INVOICE } from '../../../config/documents';

export function InvoicesUploader({ shipment, stop, onUpload, onUploadFailed }) {
  const { t } = useTranslation();
  const { uploading, handleUpload } = useHandleUploadDocuments(
    shipment,
    stop,
    async (shipment, stop, type, uploadedData, userVisibility) => {
      return onUpload(shipment, stop, type, uploadedData, userVisibility);
    },
    onUploadFailed,
  );

  const { validating, invalidPDFs, handleValidate } = useValidateDocuments(
    (validFiles) => {
      return handleUpload(validFiles, CARRIER_INVOICE.value);
    },
  );

  return (
    <div>
      {(validating || uploading) && (
        <LoadingCircle text={t('PROCESSING_FILES')} />
      )}
      <InvalidPDFs invalidPDFs={invalidPDFs} />
      <Dropzone
        style={{
          width: '100%',
          height: 75,
          padding: 10,
          borderWidth: 2,
          borderColor: '#21b88e',
          borderStyle: 'dashed',
          borderRadius: 5,
        }}
        onDrop={handleValidate}
        multiple
        accept={ACCEPTED_FILE_TYPES}
      >
        <div>{t('CLICK_DRAG_TO_UPLOAD_INV')}</div>
      </Dropzone>
    </div>
  );
}
